import {
    Component, Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {EnumUtils} from '../../../utils/enum.utils';
import {FileSizeAttentionModalComponent} from '../../file-size-attention-modal/file-size-attention-modal.component';
import {FileTypeEnum} from '../../../enums/file-type.enum';
import {TenderDocumentModel} from '../../../models/tender-document.model';
import {IModalDialogV3} from '../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';

@Component({
    selector: 'app-projects-project-documents-loader',
    templateUrl: './project-documents-loader.component.html',
    styleUrls: ['./project-documents-loader.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsProjectDocumentsLoaderComponent extends EditModalSectionBaseComponent implements OnInit {

    public isTouched = false;
    public tenderDocumentsValidationHelper = 0;

    @Input() public forceFormValidationVisibility: boolean;

    @ViewChild('tenderDocumentsValidationHelperNgModel', {static: true}) tenderDocumentsValidationHelperNgModel: NgModel;
    public projectHasTenderDocumentTestFn = (value: any) => {
        if ( !( this.model && this.model.project) ) {
            return true;
        }
        if ( ! this.model.project.isTender) {
            return true;
        }
        return this.model.project?.tenderDocuments.length > 0;
    }

    public ngOnInit(): void {
        super.ngOnInit();
    }

    public constructor(
        public  editModalService: EditModalService,
        private modalDynamicV3Service: ModalDynamicV3Service
    ) {
        super(editModalService);
    }

    public onDocumentClicked(index: number) {
        // console.log('document clicked', this.model.project.tenderDocuments[index]);
    }


    public onDocumentRemoveBtnClicked(index: number) {
        this.model.project.tenderDocuments.splice(index, 1);
        if (this.model.project.tenderDocuments.length === 0) {
            document.getElementById('loader-button').focus();
        }
        this.revalidateTenderDocumentsCount();
    }


    public processFile(htmlInput: HTMLInputElement) {
        // PPU_log console.log('htmlInput', htmlInput.files);

        const file: File = htmlInput.files[0];

        if (file) {
            let SizesSum = file.size;
            this.model.project.tenderDocuments.forEach(doc => {
                SizesSum += doc.fileSizeInByte;
            });


            if (SizesSum > 10485760) {
                const dialogRef: IModalDialogV3 = this.modalDynamicV3Service.open(FileSizeAttentionModalComponent);
                dialogRef.subscribe((val: { dialogConfirmed: boolean, msg: string }) => {

                    if (val.dialogConfirmed) {
                    }
                });
                return;
            }

            const reader = new FileReader();

            reader.addEventListener('load', (event: any) => {

                const newFile = {
                    fileName: file.name,
                    fileSizeInByte: file.size,
                    fileContent: event.target.result,
                } as TenderDocumentModel;


                const match = newFile.fileName.match(/.+.(pdf|xls|doc|docx|xlsx)\s*$/i);
                let fileType = match && match[1];
                if (fileType) {
                    fileType = fileType.toUpperCase();
                    newFile.fileType = EnumUtils.checkKey(FileTypeEnum, fileType);
                } else {
                    console.warn('fileType was not recognized ', newFile);
                }

                // console.log('newFile.fileContent ', newFile.fileContent );
                newFile.fileContent = newFile.fileContent.substring( newFile.fileContent.indexOf('base64,') + 7);
                // console.log('newFile.fileContent ', newFile.fileContent );

                this.model.project.tenderDocuments.push(newFile);
                // PPU_log console.log('new file added:', this.model.project.tenderDocuments);

                this.revalidateTenderDocumentsCount();
            });

            reader.readAsDataURL(file);
        }

        htmlInput.value = '';
        // PPU_log console.log('htmlInput end', htmlInput.files);
    }


    public setAsTouched($event) {

        if ($event.relatedTarget) {
            if ($event.relatedTarget.id.indexOf('loader') === -1) {
                this.isTouched = true;

                // PPU_log console.log('tenderDocumentsValidationHelperNgModel ===========', this.tenderDocumentsValidationHelperNgModel);
                this.revalidateTenderDocumentsCount();
                this.tenderDocumentsValidationHelperNgModel.control.markAsTouched();
            }
        }
    }

    public revalidateTenderDocumentsCount() {
        this.tenderDocumentsValidationHelperNgModel.control.updateValueAndValidity();
    }
}
